import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { captureAttribution, captureReferralCode, captureCouponCode } from './utils/attribution.js'

// Before React renders: the campaign parameters are on the URL right now and
// nowhere else, and a redirect or client-side navigation can drop them.
captureAttribution()
captureReferralCode()
captureCouponCode()

// The prerendered description and canonical are for crawlers that skip JS.
// Helmet sets its own per page, so drop these or each route gets two. The
// <title> stays: React inserts each page's title ahead of it, and it is the
// fallback for the few routes that set none.
document.querySelectorAll('meta[data-route-head], link[data-route-head]').forEach((el) => el.remove())

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
